/*
Biography Data
--------------
*/

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
//import InstagramIcon from '@mui/icons-materialInstagram';
//import TwitterIcon from '@mui/icons-materialTwitter';
//import GetAppIcon from '@mui/icons-materialGetApp';
// import DescriptionIcon from '@mui/icons-material/Description';

const Bio = [
  {
    header:
      "A Full-stack engineer and technical leader based in Seattle 🇺🇸.",
    currentRole: "Director of Engineering",
    currentOrg: "Gener8tor",
    orgSite: "https://www.gener8tor.com",
    description:
      "I am the subsequent result of self-taught passion, tutorials, and the “learn by doing” methodology. I build systems that scale, ship products that matter, and solve problems that don't have obvious answers.",
    image: "/images/about/NasirAbdirahman.jpg",
    backgroundImage: "/images/about/background.jpg",
    links: [
      //Contact Component
      {
        //LinkedIn
        id: 0,
        title: "LinkedIn",
        icon: <LinkedInIcon style={{ fontSize: 50 }} />,
        url: "https://www.linkedin.com/in/nasir-abdirahman/",
      },
      {
        //Github
        id: 1,
        title: "GitHub",
        icon: <GitHubIcon style={{ fontSize: 50 }} />,
        url: "https://github.com/NasirAbdirahman",
      },
      /*{
                //Instagram
                id:2,
                title: "Instagram",
                icon:<InstagramIcon style={{ fontSize: 50}}/>,
                url: "https://www.instagram.com/nasir.abdirahman/",
            },
            {
                //Twitter
                id:3,
                title: "Twitter",
                icon:<TwitterIcon style={{ fontSize: 50 }}/>,
                url: "https://twitter.com/NenoAbdirahman",
            },*/
      // {
      //     //Resume on Google Drive
      //     id:4,
      //     title: "Resume",
      //     icon: <DescriptionIcon style={{ fontSize: 50 }}/>,
      //     url: "https://drive.google.com/file/d/1r3vPhTUWA0F3OZ5Xjk9sfxQIhzsDQ9kh/view?usp=share_link",
      // }
    ],
    skills: [
      //Areas of Expertise Component

      //LANGUAGES
      { id: 0, title: "Python", src: "/icons/python.svg" },
      { id: 1, title: "JavaScript", src: "/icons/javascript.svg" },
      { id: 2, title: "TypeScript", src: "/icons/typescript.svg" },
      { id: 3, title: "HTML5", src: "/icons/html-5.svg" },
      { id: 4, title: "CSS", src: "/icons/css-3.svg" },

      //FRONT-END
      { id: 5, title: "ReactJS", src: "/icons/react.svg" },
      { id: 6, title: "HTMX", src: "/icons/htmx.svg" },
      { id: 7, title: "React Native", src: "/icons/ReactNative.png" },
      { id: 8, title: "Material UI", src: "/icons/material-ui.svg" },
      { id: 9, title: "TailwindCSS", src: "/icons/tailwindcss.svg" },
      { id: 10, title: "Remix", src: "/icons/remix.svg" },
      {
        id: 11,
        title: "Styled Comps.",
        src: "/icons/StyledComponentslogo.png",
      },
      { id: 12, title: "Bootstrap", src: "/icons/bootstrap-logo.svg" },
      { id: 13, title: "ThreeJS", src: "/icons/threeJS.png" },
      { id: 14, title: "jQuery", src: "/icons/jquery.svg" },
      { id: 15, title: "Redux", src: "/icons/redux.svg" },
      { id: 16, title: "React Router", src: "/icons/react-router.svg" },
      { id: 17, title: "React Spring", src: "/icons/react-spring.svg" },
      // { id: 18, title: "@use-gesture", src: "/icons/use-gesture.svg" },
      //{id:18, title:"NextJS", src:"/icons/gatsby.svg"}, // WILL LEARN by Project

      //BACK-END
      { id: 18, title: "Django", src: "/icons/django-icon.svg" },
      { id: 19, title: "Node.JS", src: "/icons/nodejs.svg" },
      { id: 20, title: "Express", src: "/icons/express.svg" },
      { id: 21, title: "PostgreSQL", src: "/icons/postgresql.svg" },
      { id: 22, title: "MongoDB", src: "/icons/mongodb.svg" },
      { id: 23, title: "Redis", src: "/icons/redis.svg" },
      //{id:24, title:"GraphQL", src:"/icons/graphql.svg"}, // WILL LEARN by Project

      //TOOLS
      { id: 24, title: "NPM", src: "/icons/npm.svg" },
      { id: 25, title: "Yarn", src: "/icons/yarn.svg" },
      { id: 26, title: "Git", src: "/icons/git.svg" },
      { id: 27, title: "Github", src: "/icons/github-icon.svg" },
      { id: 28, title: "Selenium", src: "/icons/selenium.svg" },
      { id: 29, title: "Playwright", src: "/icons/playwright.svg" },
      { id: 30, title: "Webpack", src: "/icons/webpack.svg" },
      { id: 31, title: "Babel", src: "/icons/babel.svg" },
      { id: 32, title: "Jest", src: "/icons/jest.svg" },
      { id: 33, title: "Expo SDK", src: "/icons/expo-icon.svg" },
      { id: 34, title: "Postman", src: "/icons/postman-icon.svg" },
      { id: 35, title: "JIRA", src: "/icons/jira.svg" },
      { id: 36, title: "BitBucket", src: "/icons/bitbucket.svg" },
      { id: 37, title: "Heroku", src: "/icons/heroku.svg" },
      { id: 38, title: "AWS Cloud", src: "/icons/aws.svg" },
      { id: 39, title: "AWS S3", src: "/icons/aws-s3.svg" },
      { id: 40, title: "AWS Amplify", src: "/icons/aws-amplify.svg" },
      { id: 41, title: "Docker", src: "/icons/docker-icon.svg" },
      //{id:42, title:"GatsbyJS", src:"/icons/gatsby.svg"}, // WILL LEARN by Project
      //{id:43, title:"D3", src:"/icons/d3.svg"}, // WILL LEARN by Project
    ],

    existenceStatements: [
      {
        id: 0,
        title:
          "I value love and positivity. I am a supporter of FC Barcelona. I currently hold a personal record of 37 pullups, no time limit. I am also a proud member of the largest soccer group in the Seattle area, with over 1.5k people on the waiting list, and I hardly attend meetups. I look for any excuse to enjoy the beautiful PNW weather, especially on rainy days.",
      },
      {
        id: 1,
        title:
          "I am an amateur traveler and I have been to 4 countries and counting.",
      },
      {
        id: 2,
        title:
          "I approach engineering by understanding the problem deeply before writing code. I ask the questions that clarify requirements, challenge assumptions when needed, and create clear roadmaps to delivery. I'm comfortable translating technical decisions into business impact for stakeholders and bridging the gap between engineering and business.I take full ownership, not just of code, but of outcomes.",
      },
      {
        id: 3,
        title:
          "I'm driven by systems thinking: how do we build faster, ship smarter, and eliminate bottlenecks that slow teams down? I've automated deployments that used to take hours, replaced expensive software with internal tools, and designed architectures that handle growth without collapsing. I thrive in environments where moving fast matters but ensuring that we don't move recklessly.",
      },
      {
        id: 4,
        title:
          "I am kind, compassionate, and approach every situation with empathy. I thrive in team-first environments, where collaboration and mutual support create a strong foundation for success. I strongly advocate for psychological safety in teams, believing that respecting each person's preferences, differences, and personalities is not just important but a fundamental responsibility in any organization. A team that prioritizes these values creates an environment where people can thrive, collaborate, and ultimately succeed together.",
      },
      {
        id: 5,
        title: "I pride myself on not being taught the same thing twice.",
      },
    ],
    existenceImages: [
      //TRAVEL IMAGES
      { id: 0, title: "Ijen Volcano,ID", src: "/images/about/IjenVolcano.jpg" },
      { id: 1, title: "Halong Bay,VN", src: "/images/about/HalongBay.jpg" },
    ],
    education: [
      //Education Component
      {
        id: 0,
        name: "Nucamp Coding Bootcamp",
        text: "Studied the fundamentals of full stack software development under the mentorship of industry professionals with decades of experience. I graduated with Honors in the top 10% of all students.",
        date: "Dec 2020 - May 2021",
      },
      {
        id: 1,
        name: "Western Governors University",
        text: "Dropped out of pursuing a B.S. in Computer Science.",
        date: "Nov 2020",
      },
    ],
    references: [
      //Recommendations Component
      {
        id: 0,
        name: "Leo Sinani",
        position: "Developer @ Fannie Mae",
        text: "It is with much enthusiasm that I recommend Nasir for web development position.I was Nasir's instructor for Nucamp bootcamp React class. In our class, Nasir displayed a level of creativity, wit, and analytical thought that is quite rare among other students.",
        image: "/images/about/recommenders/LeoSinani.jpg",
        relationship: "Teacher at Nucamp Coding Bootcamp",
        date: "09/2021",
      },
      {
        id: 1,
        name: "Flor Antara",
        position: "Software Engineer @ Twilio",
        text: "Nasir was one of my students in the NuCamp fullstack bootcamp. He's so passionate and dedicated that it was a pleasure to work with him. He always went the extra mile learning more in depth about the topic given and he even helped me clarify topics to the rest of the class. He's a go-getter and a team player. I'm sure he'll excel in this industry.",
        image: "/images/about/recommenders/FlorAntara.jpg",
        relationship: "Teacher at Nucamp Coding Bootcamp",
        date: "11/2021",
      },
      {
        id: 2,
        name: "Joe Baz",
        position:
          "Principal of Engineering, eCommerce @ Resource Innovations(TechniArt)",
        text: "Nasir is an excellent developer and a wonderful teammate. I had the privilege of supervising Nasir while at gener8tor, and I can attest that Nasir brings a wealth of technical skills, a passion for software development, and a can-do attitude to the job. Nasir has shown a lot of attention to detail on our projects. He knows how to ask the right questions and work with multiple stakeholders. He researches his solutions, makes clear roadmaps, and graciously works with his fellow developers. Nasir brought a lot of Django/Python/backend expertise to our team and made several high-impact contributions to our workflow. I think his strongest skill is his ability to learn and perform in a fast-paced and demanding environment. I can tell that new ideas and challenges excite Nasir, and he brings a lot of enthusiasm to the team. He was a great mentor to our junior developers and a trustworthy technical counsel for our senior management. I would strongly recommend Nasir for positions that require mastery of technical skills as well as strong interpersonal skills.",
        image: "/images/about/recommenders/Baz.jpg",
        relationship: "Managed Nasir Directly",
        date: "03/2023",
      },
      {
        id: 3,
        name: "Malorie Passman",
        position: "Talent Acquisition @ Copado",
        text: "I had the pleasure of partnering with Nasir during the hiring process for a Software Engineer on his team at gener8tor, and I can confidently say he is one of the most collaborative and supportive leaders I've worked with. As a Director of Engineering, Nasir brought a thoughtful and strategic approach to every stage of the recruitment process. He not only had a clear vision for the kind of talent he needed but also took the time to ensure I fully understood the technical requirements and nuances of the role, which is something I deeply appreciated on the recruitment side. His collaborative nature, responsiveness, and genuine respect for the hiring process made working together seamless and rewarding. Nasir not only builds high-performing teams but also uplifts the people around him in the process. Any organization would be lucky to have a leader like him on their team!",
        image: "/images/about/recommenders/mal.jpg",
        relationship: "Worked with Nasir on recruitment",
        date: "09/2025",
      },
    ],
    greetings: [
      //Greetings Component

      {
        id: 0,
        title: "Salaam",
        language: "Arabic",
      },
      {
        id: 1,
        title: "Peace",
        language: "English",
      },
      {
        id: 2,
        title: "Perdamaian",
        language: "Indonesia",
      },
    ],
  },
];

export default Bio;
